
import { httpClient } from "./Service";

export const addInvoice = async (recordData: any) => {
    try {
        const result = await httpClient("invoice/add", "POST", recordData);
        return result;
    } catch (error) {
        console.error("Error adding invoice:", error);
        throw error;
    }
};

export const getInvoice = async (payload: any) => {
    try {
        const result = await httpClient("invoice/get", "POST", payload);
        return result?.result.data;
    } catch (error) {
        console.error("Error fetching invoice:", error);
        throw error;
    }
};